document.addEventListener("DOMContentLoaded", () => {

    const cards = [...document.querySelectorAll(".timeline-card")];
    const timeline = document.querySelector(".timeline");
    const progress = document.querySelector(".timeline__progress");

    const modal = document.getElementById("timelineModal");
    const modalImage = document.getElementById("timelineModalImage");
    const modalYear = document.getElementById("timelineModalYear");
    const modalTitle = document.getElementById("timelineModalTitle");
    const modalDescription = document.getElementById("timelineModalDescription");

    const closeButton = document.querySelector(".timeline-modal__close");
    const overlay = document.querySelector(".timeline-modal__overlay");

    if (!cards.length) return;

    /*====================================================
        TARJETA ACTIVA
    ====================================================*/

    function updateActiveCard() {

        const center = window.innerHeight / 2;

        let activeCard = null;
        let minDistance = Infinity;

        cards.forEach(card => {

            const rect = card.getBoundingClientRect();

            const cardCenter = rect.top + rect.height / 2;

            const distance = Math.abs(center - cardCenter);

            if (distance < minDistance) {

                minDistance = distance;
                activeCard = card;

            }

        });

        cards.forEach(card => card.classList.remove("is-active"));

        if (activeCard) {

            activeCard.classList.add("is-active");

        }

    }

    /*====================================================
        LÍNEA DE PROGRESO
    ====================================================*/

    function updateProgress() {

        const rect = timeline.getBoundingClientRect();

        const totalHeight = timeline.offsetHeight;

        const viewportCenter = window.innerHeight / 2;

        let progressHeight = viewportCenter - rect.top;

        progressHeight = Math.max(0, Math.min(progressHeight, totalHeight));

        progress.style.height = progressHeight + "px";

    }

    function updateTimeline() {

        updateActiveCard();

        updateProgress();

    }

    updateTimeline();

    window.addEventListener("scroll", updateTimeline);

    window.addEventListener("resize", updateTimeline);

    /*====================================================
        MODAL
    ====================================================*/

    function openModal(card) {

        modalYear.textContent = card.dataset.year;
        modalTitle.textContent = card.dataset.title;
        modalDescription.textContent = card.dataset.description;

        if (card.dataset.image) {

            modalImage.src = card.dataset.image;
            modalImage.alt = card.dataset.title;
            modalImage.style.display = "block";

        } else {

            modalImage.style.display = "none";

        }

        modal.classList.add("active");

        document.body.style.overflow = "hidden";

    }

    function closeModal() {

        modal.classList.remove("active");

        document.body.style.overflow = "";

    }

    cards.forEach(card => {

        card.addEventListener("click", () => {

            openModal(card);

        });

    });

    closeButton.addEventListener("click", closeModal);

    overlay.addEventListener("click", closeModal);

    document.addEventListener("keydown", (e) => {

        if (e.key === "Escape") {

            closeModal();

        }

    });

});